import { Directive, Output, EventEmitter } from '@angular/core';
import { NFormComponent, NFormValuesChange, BeforeRenderEventHandler, NFormRecordRef } from '@pebula/nform';
import { UnRx } from '@pebula/utils';
import { Router, ActivatedRoute } from '@angular/router';
import { filter, skip } from 'rxjs/operators';
import { DateTime } from 'luxon';

@Directive({
  selector: 'pbl-nform[sgStoreSearchParams]',
  standalone: false,
})
@UnRx()
export class SgStoreSearchParamsDirective<T = any> {
  @Output() afterLoadParams: EventEmitter<void>;

  constructor(
    public cmp: NFormComponent<T>,
    private router: Router,
    private route: ActivatedRoute
  ) {
    this.afterLoadParams = new EventEmitter<void>();
    cmp.beforeRender.pipe(UnRx(this)).subscribe((event) => this.loadSearchParams(event, cmp));
  }

  private loadSearchParams(event: BeforeRenderEventHandler, cmp: NFormComponent<T>): void {
    cmp.renderState
      .pipe(
        filter((state) => state === false),
        skip(1)
      )
      .subscribe((state) => {
        if (event.isRoot) {
          const filtersName = Object.keys(event.records);
          cmp.valueChanges.pipe(UnRx(this)).subscribe((event) => this.saveSearchParams(event));
          if (this.route.snapshot.queryParamMap.keys.length > 0) {
            for (let name of filtersName) {
              if (this.route.snapshot.queryParamMap.has(name)) {
                const queryParamValue = JSON.parse(this.route.snapshot.queryParamMap.getAll(name) as any);
                const recordData = event.records[name] as NFormRecordRef;
                switch (recordData.vType) {
                  case 'dateRange':
                    const start = queryParamValue.start
                      ? DateTime.fromISO(queryParamValue.start).toUTC().startOf('day')
                      : null;
                    const end = queryParamValue.end ? DateTime.fromISO(queryParamValue.end).toUTC().endOf('day') : null;
                    cmp.nForm.setValue(name, { start, end });
                    break;
                  case 'date':
                    cmp.nForm.setValue(name, DateTime.fromISO(queryParamValue).toUTC().startOf('day'));
                    break;
                  default:
                    cmp.nForm.setValue(name, queryParamValue);
                    break;
                }
              }
            }
            cmp.nForm.commitToModel();
            this.afterLoadParams.emit();
          }
        }
      });
  }

  private saveSearchParams(changes: NFormValuesChange): void {
    let queryParams: { [filterName: string]: any } = {};
    for (let change of changes) {
      if (change.currentValue !== change.previousValue) {
        queryParams[change.key] = JSON.stringify(change.currentValue);
      }
    }
    this.router.navigate([], {
      queryParams: queryParams,
      queryParamsHandling: 'merge',
    });
  }
}
